module.exports = __webpack_public_path__ + "app/images/footer/TWP_Washington_Post_2022_AW@2x.png";


//////////////////
// WEBPACK FOOTER
// ./app/images/footer/TWP_Washington_Post_2022_AW@2x.png
// module id = 468
// module chunks = 0